import {
  Component,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  ElementRef,
} from "@angular/core";
import { FieldWrapper } from "@ngx-formly/core";
import { SurveySection, SortChangedEvent } from "src/app/shared/models/survey";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-wrapper-page",
    templateUrl: "./page-wrapper.component.html",
    styleUrls: ["./page-wrapper.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PageWrapperComponent extends FieldWrapper {
  @ViewChild("fieldComponent", { read: ViewContainerRef, static: true })
  // TS2612 fix.  Added declare.
  declare fieldComponent: ViewContainerRef;

  constructor(
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {
    super();
  }

  public addQuestionClicked() {
    this.field.props.onAddQuestionClicked(
      this.field.props["section"]
    );
  }

  public editSectionClicked() {
    this.field.props.onEditSectionClicked(
      this.field.props["section"]
    );
  }

  public deleteSectionClicked() {
    this.field.props.onDeleteSectionClicked(
      this.field.props["section"]
    );
  }

  public moveOrderUp() {
    const section = this.field.props["section"] as SurveySection;
    const evt = {
      id: section.id,
      newSortId: section.sortId - 1,
    } as SortChangedEvent;
    this.field.props.onSectionOrderChanged(evt);
  }
  public moveOrderDown() {
    const section = this.field.props["section"] as SurveySection;
    const evt = {
      id: section.id,
      newSortId: section.sortId + 1,
    } as SortChangedEvent;
    this.field.props.onSectionOrderChanged(evt);
  }
  public updateSectionSortId(e){
    const section = this.field.props["section"] as SurveySection;
    const evt = {
      id: section.id,
      newSortId: e.target.value,
      exact: true
    } as SortChangedEvent;
    this.field.props.onSectionOrderChanged(evt);
  }

  public getSectionHeaderId(): string {
    const section = this.field.props["section"] as SurveySection;
    return `section-header-${section.id}`;
  }

  public getSectionContentId(): string {
    const section = this.field.props["section"] as SurveySection;
    return `section-content-${section.id}`;
  }

  public getSectionAriaDisabled(): string {
    // Check if section is disabled
    return this.field.props.disabled ? "true" : "false";
  }

  public expandSection(): void {
    this.field.props["section"].isExpanded = true;
    this.focusExpandCollapseButton();
  }

  public collapseSection(): void {
    this.field.props["section"].isExpanded = false;
    this.focusExpandCollapseButton();
  }

  private focusExpandCollapseButton(): void {
    // Use setTimeout to wait for Angular's change detection and DOM update
    setTimeout(() => {
      this.cdr.detectChanges();
      const expandButton = this.elementRef.nativeElement.querySelector('.expand-collapse-button');
      if (expandButton) {
        expandButton.focus();
      }
    }, 0);
  }
}
